const CommonStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  DELETE: 'DELETE',
  REVIEW : 'REVIEW',
  REVIEWED : 'REVIEWED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
  UNLOCKED: 'UNLOCKED',
  READ: 'READ',
  UNREAD: 'UNREAD',
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export default CommonStatusEnum;
